import React, { useState, useEffect } from 'react';

import { getOrFetchHeaderData } from '@/utils/headerCalls';
import AddressDetailsPage from '@/components/AddressDetailsPage/AddressDetailsPage';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import { getLayoutProps } from '@/utils/layout/layout';
import useDeliveryServices from '@/hooks/useDeliveryServices';
import User from '@/store/user';

export default function AddressDetails({ loginConfig, loginImage, responsiveLogo, image }) {
  const [config, setConfig] = useState();
  const [user, setUser] = useState();

  loginImage === '' ? (loginConfig = 0) : null;
  const { getOrFetchDeliveryServices } = useDeliveryServices();
  useEffect(() => {
    const user$ = User.subscribe(_user => {
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
      return;
    }
    getOrFetchDeliveryServices();
    getConfiguration();
  }, []);
  return (
    <>
      {config && (
        <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
          <AddressDetailsPage user={user} image={image} config={config} />
        </LoginLayout>
      )}
    </>
  );
}

export async function getStaticProps(context) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, context.locale);
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, context.locale);
  const image = layoutProps?.emptyStates?.address_empty_state?.url
    ? layoutProps?.emptyStates?.address_empty_state?.url
    : null;
  const [{ data: loginAllData }] = await Promise.all([getOrFetchHeaderData('login_page', context.locale)]);
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
    login_register: (await import(`../../../prebuild-data/i18n/${context.locale}/login_register.json`)).default,
    user_address: (await import(`../../../prebuild-data/i18n/${context.locale}/user_address.json`)).default,
  };

  return {
    props: {
      responsiveLogo,
      loginConfig,
      loginImage,
      messages,
      image,
    },
  };
}
